// src/utils/authFetch.js
// Interceptor global: envia cookie HttpOnly em todas as requisições para /api/*
// Importado UMA VEZ no index.js

const _originalFetch = window.fetch;

function hasHeader(headers, headerName) {
  return Object.keys(headers || {}).some(key => key.toLowerCase() === headerName.toLowerCase());
}

function getClienteId() {
  try {
    return JSON.parse(localStorage.getItem('radio-ai-user') || '{}').id || '';
  } catch {
    return '';
  }
}

window.fetch = function(url, options = {}) {
  const urlStr = typeof url === 'string' ? url : url?.url || '';
  
  if (urlStr.includes('/api/')) {
    const clienteId = getClienteId();
    const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
    const headers = { ...(options.headers || {}) };

    if (!isFormData && !hasHeader(headers, 'Content-Type')) {
      headers['Content-Type'] = 'application/json';
    }
    if (clienteId && !hasHeader(headers, 'x-cliente-id')) {
      headers['x-cliente-id'] = clienteId;
    }

    options.credentials = options.credentials || 'include';
    options.headers = headers;
  }
  
  return _originalFetch.call(window, url, options);
};
